import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/performance_module/v1`;

export function getPerformanceModules() {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/lists`,
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function getParents(id) {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/parents/${id}`,
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function getSubModuleById(id) {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/get_sub_mobule/${id}`,
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function getPerformanceModuleById(id) {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/detail/${id}`,
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function updatePerformanceModuleById(id, data) {
   return axios({
      method: "PUT",
      headers: getHeaders(),
      url: `${url}/update/${id}`,
      data
   });
}

export function deletePerformanceModuleById(id) {
   return axios({
      method: "DELETE",
      headers: getHeaders(),
      url: `${url}/archive/${id}`,
   });
}

export function createPerformanceModuleById(data) {
   return axios({
      method: "POST",
      headers: getHeaders(),
      url: `${url}/create`,
      data
   });
}
